import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import('@/views/home'),
      hidden: true,
      redirect: '/index'
    },
    {
      path: '/demo',
      component: () => import('@/components/cropper/demo'),
      hidden: true
    },
    {
      path: '/home',
      name: 'index',
      component: () => import('@/views/home'),
      children: [// 这里就是二级路由的配置
        {
          path: '/index',
          name: 'Index',
          component: () => import('@/views/index')
        },
        {
          path: '/login',
          name: 'Login',
          component: () => import('@/views/login')
        },
        {
          path: '/grade',
          name: 'Grade',
          component: () => import('@/views/grade')
        },
        {
          path: '/grade-detail',
          name: 'GradeDetail',
          component: () => import('@/views/gradeDetail')
        },
        {
          path: '/video-detail',
          name: 'VideoDetail',
          component: () => import('@/views/grade/videoDetail')
        },
        {
          path: '/order',
          name: 'Order',
          component: () => import('@/views/order')
        },
        {
          path: '/video-order',
          name: 'VideoOrder',
          component: () => import('@/views/grade/videoOrder')
        },
        {
          path: '/course',
          name: 'Course',
          component: () => import('@/views/course')
        },
        {
          path: '/teacher',
          name: 'Teacher',
          component: () => import('@/views/teacher')
        },
        {
          path: '/activity',
          name: 'Activity',
          component: () => import('@/views/activity')
        },
        {
          path: '/activity-detail',
          name: 'ActivityDetail',
          component: () => import('@/views/activityDetail')
        },
        {
          path: '/about',
          name: 'About',
          component: () => import('@/views/about')
        },
        {
          path: '/download',
          name: 'Download',
          component: () => import('@/views/download')
        }
      ]
    },
    {
      path: '/mine',
      name: 'mine',
      component: () => import('@/views/student/mine'),
      redirect: '/user-info',
      children: [// 这里就是二级路由的配置
        {
          path: '/user-info',
          name: 'Userinfo',
          component: () => import('@/views/student/userinfo'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/user-order',
          name: 'UserOrder',
          component: () => import('@/views/student/userOrder'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/order-pay',
          name: 'UserOrderPay',
          component: () => import('@/views/student/userOrderPay'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/vicdeo-order-pay',
          name: 'VideoOrderPay',
          component: () => import('@/views/student/components/videoOrderPay'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/user-total',
          name: 'UserTotal',
          component: () => import('@/views/student/userTotal'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/user-grade',
          name: 'UserGrade',
          component: () => import('@/views/student/userGrade'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/user-leave',
          name: 'UserLeave',
          component: () => import('@/views/student/userLeave'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/user-leave-apply',
          name: 'LeaveApply',
          component: () => import('@/views/student/leaveApply'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/user-setting',
          name: 'userSetting',
          component: () => import('@/views/student/userSetting'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/feedback',
          name: 'feedback',
          component: () => import('@/views/student/feedback'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/feedback-apply',
          name: 'feedbackApply',
          component: () => import('@/views/student/feedbackApply'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/updatepwd',
          name: 'updatepwd',
          component: () => import('@/views/student/updatepwd'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/user-wallet',
          name: 'userWallet',
          component: () => import('@/views/student/userWallet'),
          meta: {
            requireAuth: true
          }
        }
      ]
    },
    {
      path: '/teacher-login',
      name: 'TeacherLogin',
      component: () => import('@/views/teacher/login')
    },
    {
      path: '/teacher-center',
      name: 'TeacherCenter',
      component: () => import('@/views/teacher/center'),
      redirect: '/teacher-info',
      children: [// 这里就是二级路由的配置
        {
          path: '/teacher-setting',
          name: 'TeacherSetting',
          component: () => import('@/views/teacher/teacherSetting'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-setpwd',
          name: 'TeacherUpdatepwd',
          component: () => import('@/views/teacher/updatepwd'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-leave',
          name: 'TeacherLeave',
          component: () => import('@/views/teacher/studentLeave'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-info',
          name: 'TeacherInfo',
          component: () => import('@/views/teacher/teacherInfo'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-total',
          name: 'ClassTotal',
          component: () => import('@/views/teacher/classTotal'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/class-call',
          name: 'ClassCall',
          component: () => import('@/views/teacher/classCall'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/call-student',
          name: 'ClassCallStudent',
          component: () => import('@/views/teacher/classCallStudent'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-work',
          name: 'ClassWorkList',
          component: () => import('@/views/teacher/classWork'),
          meta: {
            teacherAuth: true
          }
        },
        {
          path: '/teacher-work-detail',
          name: 'ClassWorkDetail',
          component: () => import('@/views/teacher/components/classWork/WorkDetail'),
          meta: {
            teacherAuth: true
          }
        }
      ]
    },
    {
      path: '/mobile',
      name: 'Mobile',
      component: () => import('@/views/mobile/index'),
      meta: {
        mobile: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-bind',
      name: 'MobileBind',
      component: () => import('@/views/mobile/bind'),
      meta: {
        mobile: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-course',
      name: 'MobileCourse',
      component: () => import('@/views/mobile/course'),
      meta: {
        mobile: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-course-detail',
      name: 'MobileCourseDetail',
      component: () => import('@/views/mobile/courseInfo'),
      meta: {
        mobile: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-video-detail',
      name: 'MobileVideoDetail',
      component: () => import('@/views/mobile/components/videoInfo'),
      meta: {
        mobile: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-order',
      name: 'MobileOrder',
      component: () => import('@/views/mobile/order'),
      meta: {
        mobile: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-video-order',
      name: 'MobileVideoOrder',
      component: () => import('@/views/mobile/components/videoOrder'),
      meta: {
        mobile: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-mine',
      name: 'MobileMineCenter',
      component: () => import('@/views/mobile/mine'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-updpwd',
      name: 'MobileUpdatepwd',
      component: () => import('@/views/mobile/mine/updatepwd'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-setting',
      name: 'MobileSetting',
      component: () => import('@/views/mobile/mine/userSetting'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-leave',
      name: 'MobileLeave',
      component: () => import('@/views/mobile/mine/leave'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-class-time',
      name: 'MobileClassTime',
      component: () => import('@/views/mobile/mine/classTime'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-orders',
      name: 'MobileOrderList',
      component: () => import('@/views/mobile/mine/orderList'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-video-orders',
      name: 'MobileVideoOrderList',
      component: () => import('@/views/mobile/mine/videoOrderList'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-course-total',
      name: 'MobileCourseTotal',
      component: () => import('@/views/mobile/mine/courseTotal'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-class-call',
      name: 'MobileClassCall',
      component: () => import('@/views/mobile/mine/classCallList'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-download',
      name: 'MobileDownLoad',
      component: () => import('@/views/mobile/down'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-about',
      name: 'MobileAbout',
      component: () => import('@/views/mobile/about'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileCheck: true
      }
    },
    {
      path: '/mobile-form-sign',
      name: 'MobileFormSign',
      component: () => import('@/views/mobile/forms/sign'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileNotCheck: true
      }
    },
    {
      path: '/mobile-form-group',
      name: 'MobileFormGroup',
      component: () => import('@/views/mobile/forms/group'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileNotCheck: true
      }
    },
    {
      path: '/mobile-form-sign-detail',
      name: 'MobileFormSignDetail',
      component: () => import('@/views/mobile/forms/signDetail'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileNotCheck: true
      }
    },
    {
      path: '/mobile-order-wechat',
      name: 'MobileOrderWechat',
      component: () => import('@/views/mobile/orderpay/wechatPay'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileNotCheck: true
      }
    },
    {
      path: '/mobile-order-alipay',
      name: 'MobileOrderAlipay',
      component: () => import('@/views/mobile/orderpay/aliPay'),
      meta: {
        mobile: true,
        mobileAuth: true,
        mobileNotCheck: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js